<template>
  <div class="theme-general-faq">
    <div
      class="title-aq">
      <h1>Tema general 2</h1>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
      Nam consectetur quis nibh sed consectetur.
      </p>
    </div>
    <el-collapse
      v-for="(aq, index) in aqs"
      :key="index">
      <el-collapse-item
        v-bind="aqs"
        :title="aq.title"
        :name="index">
        <div> {{ aq.text }}</div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: 'GeneralThemeTwo',
  data () {
    return {
      aqs: [
        {
          title: '¿Donec congue massa at magna mattis finibus?',
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing ' +
          'elit. Aenean congue id dui id lobortis. In commodo consequat ' +
          'auctor. Cras aliquam non velit vel convallis. Proin tellus felis, ' +
          'consequat ut lacus sed, sollicitudin pulvinar ante. Donec fringilla' +
          ' ante id mi cursus, eget luctus lorem consectetur. Vestibulum ' +
          'imperdiet ligula pharetra, vestibulum augue sed, posuere orci. ' +
          'Phasellus ac arcu nec purus aliquet maximus. Sed eu ultricies ' +
          'magna, quis volutpat nulla. Donec sollicitudin bibendum porttitor.' +
          ' Morbi ultricies ante velit, sed posuere nisi laoreet id. ' +
          'Pellentesque vehicula egestas rutrum. Duis commodo, erat lacinia ' +
          'eleifend fringilla, ante nibh dictum dui, nec condimentum m' +
          'etus orci dignissim purus. Sed ante sem, placerat vitae enim eu,' +
          ' aliquam commodo arcu. Curabitur in malesuada quam, imperdiet elementum lorem.'
        },
        {
          title: 'Pregunta 2',
          text: 'Aquí una breve descripción de éste apartado, aplica para preguntas frecuetes y legales.'
        },
        {
          title: 'Pregunta 3',
          text: 'Aquí una breve descripción de éste apartado, aplica para preguntas frecuetes y legales.'
        },
        {
          title: 'Pregunta 4',
          text: 'Aquí una breve descripción de éste apartado, aplica para preguntas frecuetes y legales.'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .faq-contact{
    margin-top: 22px;
  }

</style>



// WEBPACK FOOTER //
// src/components/faq/general-theme-two.vue